import { useAutoMinimizeSidebar } from "CustomHooks/useAutoMinimizeSidebar";
import React from "react";
import { useParams } from "react-router-dom";
import QuotationForm from "./Form/QuotationForm/QuotationForm";

const QuotationCreateForm: React.FC = () => {
  const { id: enquiryId } = useParams<{ id: string }>();

  // Auto-minimize sidebar on tablet screens
  useAutoMinimizeSidebar();

  return <QuotationForm enquiryId={enquiryId} />;
};

export default QuotationCreateForm;
